import Flareon from './Flareon';

export default Flareon;



/** WEBPACK FOOTER **
 ** ./source/136-flareon/index.js
 **/